import { useState } from "react";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import axios from "axios";
import getAPI from "../../service/getAPI";
import ExcelTable from "./table";

const ExcelUploadForm = ({ onUploadSuccess }) => {
  const { master } = getAPI();
  const [excelData, setExcelData] = useState(null);
  const [isUploaded, setIsUploaded] = useState(false); // Track upload status

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const fileName = file.name.toLowerCase();

    if (fileName.endsWith(".csv")) {
      Papa.parse(file, {
        dynamicTyping: true,
        header: true,
        skipEmptyLines: true,
        complete: (result) => {
          setExcelData({ data: result.data, file });
        },
      });
    } else if (fileName.match(/\.xlsx$|\.xls$|\.xlsm$|\.xlsb$/)) {
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);

      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet);

        setExcelData({ data: jsonData, file });
      };
    } else {
      alert("Invalid file format. Please upload a CSV or Excel file.");
    }
  };

  const handleBulkUpload = async (e) => {
    e.preventDefault();
    if (!excelData || !excelData.file) {
      alert("Please select a file before uploading.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("file", excelData.file);

      const response = await axios.post(master.upload_excel, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      console.log("Upload Response:", response.data);
      alert("Data uploaded successfully!");

      setIsUploaded(true); // Hide upload button after successful upload
      onUploadSuccess(); // Close modal & reload table
    } catch (error) {
      console.error("Upload failed", error);
      alert("Upload failed. Please try again.");
    }
  };

  return (
    <div>
      {!excelData && !isUploaded && (
        <div className="col-md-12 pb-4">
          <label htmlFor="fileUpload" className="form-label">
            Upload CSV or Excel File
          </label>
          <input
            type="file"
            className="form-control"
            id="fileUpload"
            onChange={handleFileChange}
            accept=".csv, .xlsx, .xls, .xlsm, .xlsb"
          />
        </div>
      )}

      {excelData && !isUploaded && (
        <>
          {/* Show Preview Table */}
          <ExcelTable userData={excelData} />

          {/* Show Upload Button */}
          <button className="btn btn-primary my-3" onClick={handleBulkUpload}>
            Upload
          </button>
        </>
      )}
    </div>
  );
};

export default ExcelUploadForm;
